import { createContext } from 'react';
import type { AuthSnapshot } from '@/lib/auth';

export type AuthContextValue = AuthSnapshot & {
  isResolvingAuth: boolean;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
